/* GW: copies the empty-cart links (template #gw-cart-empty-tpl in snippets/gw-cart-empty.liquid)
   into the cart drawer's empty state. Re-runs when the drawer re-renders after a cart change. */
(function () {
  if (window.gwCartEmptyLoaded) { return; }
  window.gwCartEmptyLoaded = true;
  function inject() {
    var tpl = document.getElementById('gw-cart-empty-tpl');
    if (!tpl || !tpl.content) { return; }
    document.querySelectorAll('.mini-cart__empty').forEach(function (box) {
      if (box.querySelector('.gw-cart-empty')) { return; }
      box.appendChild(tpl.content.cloneNode(true));
      box.classList.add('gw-has-nav');
    });
  }
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(inject, 100);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
